import {PropsWithChildren} from 'react';
import clsx from 'clsx';
import {FieldType} from '@/model/types/field';

type FieldGridProps = PropsWithChildren<{
  columnCount: number;
}>;

export const FieldGrid = ({children, columnCount}: FieldGridProps) => {
  return (
    <div
      className={clsx(
        'grid gap-4',
        columnCount === 12 && 'grid-cols-12',
        columnCount === 8 && 'grid-cols-8',
        columnCount === 6 && 'grid-cols-6',
        columnCount === 4 && 'grid-cols-4',
        columnCount === 3 && 'grid-cols-3',
        columnCount === 2 && 'grid-cols-2',
      )}
    >
      {children}
    </div>
  );
};

type FieldGridCellProps = PropsWithChildren<{
  colSpan?: number;
  devHighlighted?: boolean;
  devLabel?: string;
  hidden?: boolean;
  fieldType?: FieldType;
}>;

export const FieldGridCell = ({
  children,
  devHighlighted,
  devLabel,
  colSpan,
  hidden = false,
  fieldType,
}: FieldGridCellProps) => {
  return (
    <div
      data-field-type={fieldType}
      className={clsx(
        hidden && 'hidden',
        !hidden && 'relative',
        devHighlighted && 'border border-dashed border-charcoal bg-greige p-3',
        colSpan == 2 && 'col-span-2',
        colSpan == 3 && 'col-span-3',
        colSpan == 4 && 'col-span-4',
        colSpan == 5 && 'col-span-5',
        colSpan == 6 && 'col-span-6',
        colSpan == 7 && 'col-span-7',
        colSpan == 8 && 'col-span-8',
        colSpan == 9 && 'col-span-9',
        colSpan == 10 && 'col-span-10',
        colSpan == 11 && 'col-span-11',
        colSpan == 12 && 'col-span-12',
      )}
    >
      {children}

      {devLabel && <div className="absolute bottom-0 end-0 bg-violet px-2 py-1 text-xs text-white">{devLabel}</div>}
    </div>
  );
};

FieldGrid.Cell = FieldGridCell;
